var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 18,7 V 4 C 18,2.9 17.1,2 16,2 H 8 C 6.9,2 6,2.9 6,4 V 7 H 5 v 6 l 3,6 v 3 h 8 v -3 l 3,-6 V 7 Z M 7.1864407,3.3898305 16.915254,3.2881356 V 7 H 13.99 V 5 h -1 V 7 H 11 V 5 H 10 V 7 H 7.1864407 Z M 17.915254,12.53 14.813559,18.93678 v 1.876779 L 9.2881356,20.711864 V 18.835085 L 6.1864407,12.631694 V 8.0847458 L 17.915254,8.1864407 Z",
    style: {
      stroke: "none",
      strokeWidth: 2,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDisconnect);
export default __webpack_public_path__ + "static/media/imgDisconnect.15e092f4dc88338abdbf596f8d7e938c.svg";
export { ForwardRef as ReactComponent };